import HoleForm from '@/components/rounds/[roundId]/hole/[holeNumber]/HoleForm';
import useRound from '@/lib/rounds/hooks/useRound';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/rounds/$roundId/hole/$holeNumber')({
    component: RouteComponent,
});

function RouteComponent() {
    const { roundId: roundIdString, holeNumber: holeNumberString } = Route.useParams();
    const holeNumber = parseInt(holeNumberString);
    const roundId = parseInt(roundIdString);
    const { round, isLoading, setQueryData } = useRound({ id: roundId });

    if (isLoading || !round) {
        return null;
    }
    const hole = round.holes.find(hole => {
        return hole.hole_number === holeNumber;
    });
    return <HoleForm hole={hole} holeNumber={holeNumber} round={round} setQueryData={setQueryData} />;
}
